import React from 'react';
import { CTAButton } from './CTAButton';
export function ValueStack() {
  return <section id="value" aria-label="Final offer" className="bg-plum text-white" data-id="element-278" data-mp="24848wxt8j1qh">
      <div className="mx-auto max-w-3xl px-5 py-14 text-center" style={{
      paddingTop: "22px",
      paddingBottom: "2px"
    }} data-id="element-279" data-mp="245rkq2wvvv4z">
        <h2 className="font-display text-2xl font-black sm:text-4xl" data-id="element-280" data-mp="1u9ok51hok4k5">
          🚀 Build a more <span className="text-grape-soft" data-id="element-281" data-mp="1ubrh65h92xyd">repeatable</span> proposal process
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-white/75" data-id="element-282" data-mp="2i1vank0q5hbn">
          You don't need to rebuild your proposal workflow from scratch every time a potential client contacts you. With
          The Freelance Proposal Machine™, you get an organized set of AI prompts, workflows, and complementary resources
          designed to help you analyze client briefs, define deliverables, structure proposals, review your work, and
          prepare for project kickoff.
        </p>
        <p className="mt-4 text-base font-semibold text-white" data-id="element-283" data-mp="35qy21jl5uojc">
          Build a process you can adapt to your services, your clients, and the way you work.
        </p>

        
      </div>
    </section>;
}